// extracted by mini-css-extract-plugin
export default {"dashboard-page-card":"card_dashboard-page-card__oZxb0"};